import { useQuery } from "@tanstack/react-query";
import { DEFAULT_STALE_TIME } from "neetocommons/constants";

import auditLogsApi from "./api";
import { COUNTRIES_LIST_QUERY_KEY } from "./constants";

export const useFetchCountries = () =>
  useQuery({
    queryKey: [COUNTRIES_LIST_QUERY_KEY],
    queryFn: auditLogsApi.fetchCountries,
    staleTime: DEFAULT_STALE_TIME,
  });
